// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-setting-fly-camera {
  /* display: none; Hidden by default */
  display: block;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 6;

  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */
  overflow: hidden;
  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

/* Modal Content */
.modal-content-setting-fly-camera {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fefefe;
  margin: auto;
  padding: 0;
  border: 1px solid #888;
  width: 400px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  -webkit-animation-name: animatetop;
  -webkit-animation-duration: 0.4s;
  animation-name: animatetop;
  animation-duration: 0.4s;
  border-radius: 10px;
}

/* Add Animation */
@-webkit-keyframes animatetop {
  from {
    top: -50%;
    transform: translate(-50%, -50%);
    opacity: 0;
  }

  to {
    top: 50%;
    opacity: 1;
  }
}

@keyframes animatetop {
  from {
    top: -50%;
    transform: translate(-50%, -50%);
    opacity: 0;
  }

  to {
    top: 50%;
    opacity: 1;
  }
}

/* The Close Button */
.close-setting-fly-camera {
  font-size: 16px;
  font-weight: bold;
  color: #888;
}

.close-setting-fly-camera:hover,
.close-setting-fly-camera:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

.modal-header-setting-fly-camera {
  padding: 7px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid lightgray;
}

.modal-body-setting-fly-camera {
  padding: 10px;
  height: 100%;
  overflow: auto;
  background-color: var(--background-color-4);
}

.modal-footer-setting-fly-camera {
  padding: 10px 10px 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

/* Form setting */

.container-list {
  display: grid;
  width: 100%;
  height: calc(100% - 302px);
  min-height: 100px;
}

.container-list .list-box {
  overflow: auto;
  min-height: 50px;
  padding: 0 5px;
}

.container-list legend {
  font-weight: 700;
}

.container-list fieldset {
  overflow: auto;
  border: 1px solid #ced4da;
}

.container-list .form__group {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.container-form .input-group {
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.input-camera-setting {
  margin: 3px 0 5px 0px;
}

.modal-resize {
  height: 12px;
  float: right;
  cursor: nw-resize;
  margin: 2px 3px 5px 0;
}

.modal-resize svg {
  width: 100%;
  height: 100%;
}

.btn-danger-dpu {
  background: #dc3545;
  border-color: #dc3545;
  color: #fff;
  padding: 0;
  height: 30px;
  width: 30px;
  padding: 4px 0px;
  outline: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-danger-dpu:hover {
  background: #bb2d3b;
  border-color: #b02a37;
  box-shadow: none;
  color: #fff;
}

.btn-danger-dpu svg {
  width: 100%;
  height: 100%;
  stroke: #fff;
  fill: #fff;
}

.btn-load-files-kmz {
  background: none;
  border: 1px solid #ced4da;
  padding: 5px;
  cursor: pointer;
  border-radius: 4px;
  min-width: 36px;
  min-height: 32px;
  color: var(--color-text-1);
}

.btn-load-files-kmz:hover {
  border: 1px solid var(--primary-color-hover-1);
  color: var(--primary-color-hover-1);
}

.btn-ok-modal {
  background: var(--primary-color-1);
  border: none;
  padding: 5px;
  min-width: 36px;
  min-height: 32px;
  cursor: pointer;
  border-radius: 5px;
  color: white;
  font-weight: 600;
}

.btn-ok-modal:hover {
  background: var(--primary-color-hover-1);
}

.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/styles/flycamera.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,UAAU;;EAEV,wBAAwB;EACxB,OAAO;EACP,MAAM;EACN,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;EAC9B,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,4EAA4E;EAC5E,kCAAkC;EAClC,gCAAgC;EAChC,0BAA0B;EAC1B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE;IACE,SAAS;IACT,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,SAAS;IACT,gCAAgC;IAChC,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA,qBAAqB;AACrB;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA,iBAAiB;;AAEjB;EACE,aAAa;EACb,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;EAC9C,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;EAClC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".modal-setting-fly-camera {\n  /* display: none; Hidden by default */\n  display: block;\n  /* Hidden by default */\n  position: fixed;\n  /* Stay in place */\n  z-index: 6;\n\n  /* Location of the box */\n  left: 0;\n  top: 0;\n  width: 100%;\n  /* Full width */\n  height: 100%;\n  /* Full height */\n  overflow: hidden;\n  /* Enable scroll if needed */\n  background-color: rgb(0, 0, 0);\n  /* Fallback color */\n  background-color: rgba(0, 0, 0, 0.4);\n  /* Black w/ opacity */\n}\n\n/* Modal Content */\n.modal-content-setting-fly-camera {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background-color: #fefefe;\n  margin: auto;\n  padding: 0;\n  border: 1px solid #888;\n  width: 400px;\n  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  -webkit-animation-name: animatetop;\n  -webkit-animation-duration: 0.4s;\n  animation-name: animatetop;\n  animation-duration: 0.4s;\n  border-radius: 10px;\n}\n\n/* Add Animation */\n@-webkit-keyframes animatetop {\n  from {\n    top: -50%;\n    transform: translate(-50%, -50%);\n    opacity: 0;\n  }\n\n  to {\n    top: 50%;\n    opacity: 1;\n  }\n}\n\n@keyframes animatetop {\n  from {\n    top: -50%;\n    transform: translate(-50%, -50%);\n    opacity: 0;\n  }\n\n  to {\n    top: 50%;\n    opacity: 1;\n  }\n}\n\n/* The Close Button */\n.close-setting-fly-camera {\n  font-size: 16px;\n  font-weight: bold;\n  color: #888;\n}\n\n.close-setting-fly-camera:hover,\n.close-setting-fly-camera:focus {\n  color: #000;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.modal-header-setting-fly-camera {\n  padding: 7px 15px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid lightgray;\n}\n\n.modal-body-setting-fly-camera {\n  padding: 10px;\n  height: 100%;\n  overflow: auto;\n  background-color: var(--background-color-4);\n}\n\n.modal-footer-setting-fly-camera {\n  padding: 10px 10px 0 10px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n/* Form setting */\n\n.container-list {\n  display: grid;\n  width: 100%;\n  height: calc(100% - 302px);\n  min-height: 100px;\n}\n\n.container-list .list-box {\n  overflow: auto;\n  min-height: 50px;\n  padding: 0 5px;\n}\n\n.container-list legend {\n  font-weight: 700;\n}\n\n.container-list fieldset {\n  overflow: auto;\n  border: 1px solid #ced4da;\n}\n\n.container-list .form__group {\n  display: flex;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.container-form .input-group {\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n}\n\n.input-camera-setting {\n  margin: 3px 0 5px 0px;\n}\n\n.modal-resize {\n  height: 12px;\n  float: right;\n  cursor: nw-resize;\n  margin: 2px 3px 5px 0;\n}\n\n.modal-resize svg {\n  width: 100%;\n  height: 100%;\n}\n\n.btn-danger-dpu {\n  background: #dc3545;\n  border-color: #dc3545;\n  color: #fff;\n  padding: 0;\n  height: 30px;\n  width: 30px;\n  padding: 4px 0px;\n  outline: none;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.btn-danger-dpu:hover {\n  background: #bb2d3b;\n  border-color: #b02a37;\n  box-shadow: none;\n  color: #fff;\n}\n\n.btn-danger-dpu svg {\n  width: 100%;\n  height: 100%;\n  stroke: #fff;\n  fill: #fff;\n}\n\n.btn-load-files-kmz {\n  background: none;\n  border: 1px solid #ced4da;\n  padding: 5px;\n  cursor: pointer;\n  border-radius: 4px;\n  min-width: 36px;\n  min-height: 32px;\n  color: var(--color-text-1);\n}\n\n.btn-load-files-kmz:hover {\n  border: 1px solid var(--primary-color-hover-1);\n  color: var(--primary-color-hover-1);\n}\n\n.btn-ok-modal {\n  background: var(--primary-color-1);\n  border: none;\n  padding: 5px;\n  min-width: 36px;\n  min-height: 32px;\n  cursor: pointer;\n  border-radius: 5px;\n  color: white;\n  font-weight: 600;\n}\n\n.btn-ok-modal:hover {\n  background: var(--primary-color-hover-1);\n}\n\n.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
